module.exports = __webpack_public_path__ + "img/doc.4ad58751.svg";